import Const from 'constants';
import {calculatePlayersRange} from 'helpers/common-helper';
import NumberHelper from 'helpers/number-helper';

let PointsBoundary = {
    setInnerPointsBoundaryFromStorage(pointsBoundary) {
        return (dispatch, getState) => {
            const {userPointsType, sportConfig} = getState();

            const pointsType = sportConfig.isUserPointsTypeUsed() ? userPointsType.getUserPointsType() : null;
            const boundaryPointsType = pointsBoundary.pointsType ?? null;

            // If current points type is different from points type in storage or inner boundaries are empty, don't update state.
            if (pointsType !== boundaryPointsType || isEmpty(pointsBoundary.innerBoundaries)) {
                return;
            }

            dispatch(this.setInnerPointsBoundary(pointsBoundary.innerBoundaries, {
                countPlayers: false,
                saveToStorage: false,
            }));
        };
    },

    setInnerPointsBoundary(boundary, options = {}) {
        return (dispatch) => {
            const {countPlayers = true, saveToStorage = true} = options;

            dispatch({
                type: Const.POINTS_BOUNDARY_SET_INNER,
                boundary,
            });

            countPlayers && dispatch(this.setPlayersCounters());

            saveToStorage && dispatch(this.saveDataToStorage('pointsBoundary', (state) => {
                const {pointsBoundary} = state;

                return {
                    innerBoundaries: pointsBoundary.getAdjustedInnerBoundaries(),
                    pointsType: pointsBoundary.getPointsType(),
                };
            }));
        };
    },

    setOuterPointsBoundary(boundary, pointsType) {
        return (dispatch, getState) => {
            const {pointsBoundary} = getState();
            const currentPointsType = pointsBoundary.getPointsType();

            dispatch({
                type: Const.POINTS_BOUNDARY_SET_OUTER,
                boundary,
                pointsType,
            });

            // Reset inner boundaries in storage if points type has changed.
            {
                const resetInStorage = currentPointsType && currentPointsType !== pointsType;

                resetInStorage && dispatch(this.saveDataToStorage('pointsBoundary', (state) => {
                    const {pointsBoundary} = state;

                    return {
                        innerBoundaries: {},
                        pointsType: pointsBoundary.getPointsType(),
                    };
                }));
            }
        };
    },

    setPointsBoundary(modeNames = []) {
        return (dispatch, getState) => {
            const {
                modesConfig,
                sportConfig,
                playersData: {players},
                userPointsType,
            } = getState();

            const modes = isEmpty(modeNames)
                ? modesConfig.all({asArr: true})
                : modeNames.map((modeName) => modesConfig.getConfig(modeName));

            const boundary = {};
            modes.map((mode) => {
                const range = calculatePlayersRange(players.all(), mode.getPropPrefix() + 'userPoints', {
                    parseValue: (value) => parseFloat(value),
                    shouldPlayerBeSkipped:
                        mode.getRole() === 'FLEX'
                            ? () => false
                            : (player) => sportConfig.isSportF1() && player.isConstructor(),
                });

                range.min = NumberHelper.prepareFloat(range.min, 3, Const.DEFAULT_VALUE_FOR_USER_POINTS_RANGE_MIN)
                    .limitByRange(
                        Const.DEFAULT_VALUE_FOR_USER_POINTS_RANGE_MIN,
                        range.min,
                        Const.DEFAULT_VALUE_FOR_USER_POINTS_RANGE_MIN,
                        range.min,
                    )
                    .get();

                if (range.min >= range.max) {
                    range.max = parseInt(range.min + 100);
                }

                boundary[mode.getRole()] = range;
            });

            const pointsType = sportConfig.isUserPointsTypeUsed() ? userPointsType.getUserPointsType() : null;

            dispatch(this.setOuterPointsBoundary(boundary, pointsType));
        };
    },
};

export default PointsBoundary;
